import Lng from "../3x1010/Lng.js";
import Pqp from "../3x1010/Pqp.js";

import Globals from "../Globals.js";
import Compare from "./Compare.js";


export default class PageCommon {
  constructor() {

  }
  init($data) {
    // Pqp.trace("PageCommon");
    this.metaInfo = ($data && $data.metaInfo) ? $data.metaInfo : null;
    //
    if (this.metaInfo) {
      history.replaceState(history.state, this.metaInfo.Title, this.metaInfo.Url + location.hash);
      document.title = metaInfo.Title;
    }
    //
    $(".js-open-menu").on("click", $.proxy(this.openMenu, this));
    $(".w-language").on("click", $.proxy(this.openLngMenu, this));
    $(".js-sticky-btn").on("click", $.proxy(this.openStickyMenu, this));

    for (var suid of editorialSecionsUids) {
      $(".js-open-" + suid + "-menu").on("click", (e) => {
        var flm = ".js-" + suid + "-menu-first-lvl";
        var $flm = $(flm);
        $flm.addClass("open");
        $(".close-menu", $flm).on("click", (e) => {
          $flm.removeClass("open");
          $(".second-level").removeClass('open');
        })
        $(".js-single-voice").on("click", $.proxy(this.openSecondLvl, this));
      });
    }

    if (this.hasTouch()) { // remove all :hover stylesheets
      try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
          var styleSheet = document.styleSheets[si];
          if (!styleSheet.rules) continue;

          for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
            if (!styleSheet.rules[ri].selectorText) continue;

            if (styleSheet.rules[ri].selectorText.match(':hover')) {
              styleSheet.deleteRule(ri);
            }
          }
        }
      } catch (ex) { }
    }
    //
    this.compare = new Compare();
    fetch('/data/public/json/data.json')
      .then(response => response.json())
      .then(result => {
        this.compare.init(result);
        $('.matchModal').on('hide.bs.modal', function (e) {
          $('body').removeClass('overflow-hidden');
          $(".js-layer-small-devices").removeClass("is-initialized");
        })
        $('.js-open-compare').click(() => {
          $('body').addClass('overflow-hidden');
          $(".js-layer-small-devices").addClass("is-initialized");
          this.compare.show();
        })
      })

    // dispaccio un evento globale
    this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
  }



  openMenu() {
    $(".js-mobile-nav").addClass("open");
    $("body").addClass("no-scroll");
    $(".overlay-menu").show();
    $(".overlay-menu").on("click", $.proxy(this.closeMenu, this));
    $(".js-close").on("click", $.proxy(this.closeMenu, this));
  }

  closeMenu() {
    $(".js-mobile-nav").removeClass("open");
    $("body").removeClass("no-scroll");
    $(".overlay-menu").hide();
  }


  openLngMenu() {
    $(".language").toggleClass("open");
    $(".dropdown-lng").toggleClass("open")
  }

  openStickyMenu() {
    $(".accordion-menu").slideToggle("swing");
  }

  hasTouch() {
    return 'ontouchstart' in document.documentElement
      || navigator.maxTouchPoints > 0
      || navigator.msMaxTouchPoints > 0;

  }

  dispatchInitEvent(evenTyepe) {
    // dispaccio un evento globale
    let ev = new Event(evenTyepe);
    ev.payload = { page: this }
    TheDisp.dispatchEvent(ev);
  }

  get isHomepage() {
    return false;

  }

  showPreloader(flag) {
    if (flag) {
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static showPreloader(flag) {
    if (flag) {
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }


  track() {
    if (Globals.SHOW_TRACKING_DATA) {
      console.log("---tracking---");
      console.log("Event: " + PageCommon._normalizza_track_prop(o.event));
      console.log("Category: " + PageCommon._normalizza_track_prop(o.category));
      console.log("Label: " + o.label ? PageCommon._normalizza_track_prop(o.label) : "n/a");
    }

    let additional = {
      event_category: PageCommon._normalizza_track_prop(o.category)
    }
    if (o.label) {
      additional.event_label = PageCommon._normalizza_track_prop(o.label);
    }

    gtag('event', PageCommon._normalizza_track_prop(o.event), additional);

  }

  _normalizza_track_prop(s) {
    let ret = s.toLowerCase();
    ret = Pqp.safeReplace(ret, " ", "_");
    ret = Pqp.safeReplace(ret, "'", "_");
    ret = Pqp.safeReplace(ret, ".", "");
    ret = Pqp.safeReplace(ret, ",", "");
    ret = Pqp.safeReplace(ret, "(", "_");
    ret = Pqp.safeReplace(ret, ")", "");
    ret = Pqp.safeReplace(ret, "__", "_");
    return ret;
  }

  static disable(mc, lFlag, opacity = 1) {
    if (lFlag) {
      mc.css("pointer-events", "none");
      mc.css("opacity", opacity);
    } else {
      mc.css("pointer-events", "all");
      mc.css("opacity", 1);
    }

  }

  headerEventHandler(e) {
    if (e.type === Header.EVENT_OPEN_LOGIN) {
      this.showLogin();
    }
    if (e.type === Header.EVENT_OPEN_LOGOUT) {
      this.showTestIndirizzo();
      //this.showLogout(); 
    }
  }

  showLogin() {
    /*let initer = {};
    initer.template = "template-login";
    initer.cls = LoginPanel;
    initer.closeButton = false;
    initer.size = LayersSize.NONE;
    initer.handler = this.loginEventsHandler.bind(this);*/

    let initer = {
      template: "template-login",
      cls: LoginPanel,
      closeButton: false,
      size: LayersSize.NONE,
      handler: this.loginEventsHandler.bind(this)
    }

    let panelLogin = new PanelWindow(initer);
    panelLogin.init();
  }

  loginEventsHandler(e) {
    //this.header.updateLoginLogout();
    if (e.additionalData) {
      if (e.additionalData.action === "showRecuperaPassword") {
        this.showRecuperaPassword();
      }
      if (e.additionalData.action === "showRegistrazioneLight") {
        this.showRegistrazioneLight();
      }
    }
  }

  showLogout() {
    /*let initer = {};
    initer.title = Lng.l("Auth.ConfirmTitleLogout");
    initer.body = Lng.l("Auth.ConfirmBodyLogout");
    initer.buttons = [Lng.l("Auth.ConfirmConfirmYes"), Lng.l("Auth.ConfirmConfirmNo")];
    initer.handler = this.logoutEventsHandler.bind(this);*/

    let initer = {
      title: Lng.l("Auth.ConfirmTitleLogout"),
      body: Lng.l("Auth.ConfirmBodyLogout"),
      buttons: [Lng.l("Auth.ConfirmConfirmYes"), Lng.l("Auth.ConfirmConfirmNo")],
      handler: this.logoutEventsHandler.bind(this)
    }

    let confirm = new ConfirmWindow(initer);
  }

  logoutEventsHandler(e) {
    if (e.index === 0) {
      this.doLogout();
      //this.showCambiaPassword();
    }
  }
  doLogout() {
    this.showPreloader(true);
    let rq = {
      ForceClearPrincipal: true
    }
    thatServiceManeger.standardCall("/api/auth/logout", rq, this.doLogoutFeedback.bind(this));
  }

  doLogoutFeedback(e) {
    this.showPreloader(false);
    //this.header.updateLoginLogout();
    // qui dovrei controllare l'esito del logout per poi cosa? Dargli una alert che il logout è fallito? Boh. 
    // Ma poi quando cazzo mai fallisce il logout? Se fallisce vuol dire che il server è in palla e allora tanto vale che non cambi nulla.
    // Probabilmente ci sarei stato meno a fargli vedere la alert che a scrivere queste cazzate ma va bene lo stesso.
  }


  // Da ricommentare se Manca cambia idea e non viene più invocato da qui ma direttamente dalla classe del login
  showRecuperaPassword() {
    let initer = {
      template: "template-recupera-password-step-0",
      cls: RecuperaPasswordStep0Panel,
      closeButton: false,
      size: LayersSize.NONE,
    }
    let panelRecuperaPassword = new PanelWindow(initer);
    panelRecuperaPassword.init();
  }


  showCambiaPassword() {
    let initer = {
      template: "template-cambia-password",
      cls: CambiaPasswordPanel,
      closeButton: false,
      size: LayersSize.NONE,
    }

    let panelCambiaPassword = new PanelWindow(initer);
    panelCambiaPassword.init({ UserName: Helper.getUserName() });
  }


  showRegistrazioneLight() {
    let initer = {
      template: "template-registrazione-light",
      cls: RegistrazioneLightPanel,
      closeButton: false,
      size: LayersSize.NONE,
      handler: this.registrazioneLightEventsHandler.bind(this)

    }

    let panelRegistrazioneLight = new PanelWindow(initer);
    panelRegistrazioneLight.init();
  }

  registrazioneLightEventsHandler(e) {
    if (e.additionalData) {
      if (e.additionalData.action === "showRecuperaPassword") {
        this.showRecuperaPassword();
      }
      if (e.additionalData.action === "showLogin") {
        this.showLogin();
      }
    }
  }

  showTestIndirizzo() {
    let initer = {
      template: "template-test-indirizzo",
      cls: TestIndirizzoPanel,
      closeButton: false,
      size: LayersSize.NONE,
    }

    let panelTestIndirizzo = new PanelWindow(initer);
    panelTestIndirizzo.init();
  }

  // ------------------------------------------------------------------------------
  // SEARCH
  // ------------------------------------------------------------------------------

  initSearchInput() {
    $(".jsSearch_q").keyup(this.onSearch_q.bind(this, true));
    $(".jsSearch_q").on("change", this.onSearch_q.bind(this, false));
    //
    $(".jsSearch_yf").keyup(this.onSearch_y.bind(this, true));
    $(".jsSearch_yt").keyup(this.onSearch_y.bind(this, true));
    $(".jsSearch_yf").on("change", this.onSearch_y.bind(this, false));
    $(".jsSearch_yt").on("change", this.onSearch_y.bind(this, false));
    //
    this.setInputFilter($(".jsSearch_yf")[0], function (value) {
      return /^\d*\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    });
    this.setInputFilter($(".jsSearch_yt")[0], function (value) {
      return /^\d*\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    });
    $(".jsSearch_qbtn").on("click", this.doSearch.bind(this, "q"));
    $(".jsSearch_ybtn").on("click", this.doSearch.bind(this, "y"));
    //
    this.onSearch_q(false);
    this.onSearch_y(false);
  }

  onSearch_q(bPress, event) {
    let minlen = 2;
    let txt = $.trim($(".jsSearch_q").val());
    let tokens = txt.split(/[ \r\n\t;,.:\-_!\"/\\?^\[\]<>()%?*~+'|&]+/);
    let isValid = false;
    for (var x of tokens)
      if (x.length >= minlen)
        isValid = true;
    if (isValid)
      $(".jsSearch_qbtn").removeClass("disabled");
    else
      $(".jsSearch_qbtn").addClass("disabled");
    //
    if (bPress && (event.keyCode || event.which) == 13 && isValid)
      this.doSearch("q");
  }

  onSearch_y(bPress, event) {
    let yf = parseInt($.trim($(".jsSearch_yf").val()));
    let yt = parseInt($.trim($(".jsSearch_yt").val()));
    let isValid = (!isNaN(yf) && yf >= 1000) || (!isNaN(yt) && yt >= 1000);
    if (isValid)
      $(".jsSearch_ybtn").removeClass("disabled");
    else
      $(".jsSearch_ybtn").addClass("disabled");
    //
    if (bPress && (event.keyCode || event.which) == 13 && isValid)
      this.doSearch("y");
  }

  doSearch(tipo) {
    let queryString = "";
    if (tipo == "q") {
      queryString = "q=" + encodeURIComponent($.trim($(".jsSearch_q").val()));
    }
    else {
      let yf = parseInt($.trim($(".jsSearch_yf").val()));
      let yt = parseInt($.trim($(".jsSearch_yt").val()));
      if (!isNaN(yf))
        queryString += (queryString == "" ? "" : "&") + "yf=" + yf;
      if (!isNaN(yt))
        queryString += (queryString == "" ? "" : "&") + "yt=" + yt;
    }
    this.showPreloader(true);
    let url = TheApp.Env.BaseUrlNls + "search?" + queryString;
    // alert(url);
    document.location.href = TheApp.Env.BaseUrlNls + "search?" + queryString;
  }

  // libreia
  setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
      textbox.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    });
  }

}



